export const getSelectedReceiver = ({ fundOpportunities: { receiver } }) =>
  receiver?.selectedReceiver;

export const getSelectedDraftReceiver = ({ fundOpportunities: { receiver } }) =>
  receiver?.selectedDraftReceiver;

export const getReceiverForm = ({ fundOpportunities: { receiver } }) =>
  receiver?.receiverForm;
